<div class="main-container">
  <!-- <session-alert></session-alert> -->
  <app-loading></app-loading>
  <simple-notifications></simple-notifications>
  <router-outlet></router-outlet>
</div>
